export const STATE: any = Object.freeze({
	FILLING: 'filling',
	REVIEWING: 'reviewing',
	EDITING: 'editing',
	VIEWING: 'viewing',
	UPDATE: 'update'
});
